import React, { useState, useRef, useEffect } from "react";
import { Grid, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { FaExclamation } from "react-icons/fa6";
import Header from "../../Components/LandingPage/LandingPageHeader";
import Footer from "../../Components/LandingPage/LandingPageFooter";
import VisionIcon from "../../Assets/Logo/LandingPageVisionIcon.svg";
import MissionIcon from "../../Assets/Logo/LandingPageMissionIcon.svg";
import GuideLineIcon from "../../Assets/Logo/LandingPageGuideLineIcon.svg";
import { OnlyDateConverter } from "../../Components/Helpers/DateTimeConverter";
import { FormatAmount } from "../../Components/Formatters/AmountFormat";
import { GreenColorButton, PrimeGrayBorderColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomModal from "../../Components/Modal/CustomModal";
import NewsSection from "../../Components/NewsSection/NewsSection";
import { motion } from "framer-motion";

import { useNavigate } from "react-router-dom";
import { GetMethod } from "../../Helper/api";
import { fetchPSCNews } from "../../Helper/newsService";
import defaultNewsImage from "../../Assets/Images/default-image.png";
const LandingPage = () => {

  const homeRef1 = useRef(null);
  const jobsRef1 = useRef(null);
  const navigate = useNavigate();

  const [RecentJobs,setRecentJobs ]= useState([])
  const [detailModal, setDetailModal] = useState(false);
  const [jobDetails, setJobDetails] = useState("");
  const [applicationAgreement, setApplicationAgreement] = useState(false);
  const [aggrement, setAggrement] = useState({ Q1: false, Q2: false, Q3: false });

  const [latestNews, setLatestNews] = useState([]);
  const [newsLoading, setNewsLoading] = useState(true);
  const [newsError, setNewsError] = useState(null);

  const OpenDetailModal = (data) => {
    setDetailModal(true);
    setJobDetails(data);
  }

  const CloseDetailModal = () => {
    setDetailModal(false);
    setJobDetails("");
    setAggrement({ Q1: false, Q2: false, Q3: false });
  }

  const OpenAgreementModal = (data) => {
    navigate("/candidatelogin")
    setApplicationAgreement(false);
    setJobDetails(data);
  }

  const CloseAgreementModal = () => {
    setDetailModal(false);
    setApplicationAgreement("");
    setAggrement({ Q1: false, Q2: false, Q3: false });
  }

  const ChangeAggrement = (value, field) => {
    setAggrement((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }
  useEffect(()=>{
    GetRecentjobs()
    GetLatestNews()
  },[])
  
  const GetRecentjobs=async()=>{
    try{
      let url = "job/listrecentjob";
      let method = "GET";
      const response = await GetMethod({ url, method });
      if(response.status){
        setRecentJobs(response.result)
      }

    }catch(error){
      console.error("GetRecentjobs Error ", error)
    }
  }

  const GetLatestNews = async () => {
    try {
      setNewsLoading(true);
      setNewsError(null);
      const news = await fetchPSCNews(3);
      setLatestNews(news);
    } catch (error) {
      console.error("Error fetching news:", error);
      setNewsError(error.message);
      setLatestNews([]);
    } finally {
      setNewsLoading(false);
    }
  }

  const OpenApplication = () => {
    if (!aggrement.Q1 || !aggrement.Q2 || !aggrement.Q3) {
      toast.error("Please Agree All the Instruction Conditions Before Proceed");
      return
    }
    toast.success("Job Applied Successfully");
    CloseAgreementModal();
  }

  const handleNewsClick = (newsItem) => {
    if (newsItem.link) {
      window.open(newsItem.link, "_blank", "noopener,noreferrer");
    }
  }

  const getNewsImage = (newsItem) => {
    // Use featured image if available, otherwise use default image
    return newsItem.featuredImage || newsItem.bannerPic || defaultNewsImage;
  }

  return (
    <Grid item container lg={12} >
      <Header homeRef={homeRef1} jobsRef={jobsRef1} />
      <Grid ref={homeRef1} style={{marginTop:100}} item container lg={12} alignItems={"center"} className={window.innerWidth > 768 ? "landingbgbanner" : "landingbgbanner1"} padding={window.innerWidth > 768 ? 6 : 2} sx={{ height: window.innerWidth > 768 ? "90vh" : "50vh" }}>
        <Grid item container lg={5.8} md={5.8} sm={12} xs={12}>
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <h1 className="poppinsMedium Text-Prime-White text-left w-100">POLICE SERVICE COMMISSION</h1>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <h2 className="poppinsSemiBold Text-Prime-Green text-left pt-2 w-100">FEDERAL REPUBLIC OF NIGERIA</h2>
          </motion.div>
        </Grid>
        <Grid item container lg={5.8} md={5.8} sm={12} xs={12}></Grid>
      </Grid>
      <Grid item container lg={12} md={12} sm={12} xs={12} alignItems={"center"} padding={window.innerWidth > 768 ? 6 : 2} className="bg-white">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
          <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"wrap"} display={"flex"} justifyContent={"space-between"}>
            <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="landingPagebox" padding={window.innerWidth > 768 ? "2%" : "4%"} marginTop={window.innerWidth > 768 ? 0 : "4%"}>
              <img
                src={MissionIcon}
                alt="VisionIcon"
                className="landingIcon"
              />
              <h3 className="poppinsMedium heading text-left pt-3 w-100">Vision:</h3>
              <p className="poppinsRegular description text-left pt-3 w-100">A highly motivated, professional, disciplined and accountable Police Service that upholds Human Rights</p>
            </Grid>
            <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="landingPagebox" padding={window.innerWidth > 768 ? "2%" : "4%"}>
              <img
                src={VisionIcon}
                alt="VisionIcon"
                className="landingIcon"
              />
              <h3 className="poppinsMedium heading text-left pt-3 w-100">Mission Statement:</h3>
              <p className="poppinsRegular description text-left pt-3 w-100">To improve service delivery in the Nigeria Police Force by promoting transparency and accountability in the police.</p>
            </Grid>
           
            <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="landingPagebox" padding={window.innerWidth > 768 ? "2%" : "4%"} marginTop={window.innerWidth > 768 ? 0 : "4%"}>
              <img
                src={GuideLineIcon}
                alt="VisionIcon"
                className="landingIcon"
                style={{ width: "8%" }}
              />
              <h3 className="poppinsMedium heading text-left pt-3 w-100">Guiding Principles</h3>
              <p className="poppinsRegular description text-left pt-3 w-100">The Police Service Commission, in the conduct of its role in decision making, interactions with the Police and other stakeholders, will be governed by the following overriding principles irrespective of circumstance:</p>
              <p className="poppinsRegular description text-left pt-3 w-100"> 1. Uphold the rule of law</p>
              <p className="poppinsRegular description text-left pt-3 w-100"> 2. Respect for the rights of citizens in carrying out their duties. </p>
              <p className="poppinsRegular description text-left pt-3 w-100"> 3. Merit</p>
              <p className="poppinsRegular description text-left pt-3 w-100"> 4. Integrity</p>
            </Grid>
          </Grid>
        </motion.div>
      </Grid>
      <Grid ref={jobsRef1} item container lg={12} md={12} sm={12} xs={12} alignItems={"center"} padding={window.innerWidth > 768 ? 6 : 2} sx={{ backgroundColor: "#F3F3F3" }}>
        <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"wrap"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Grid item container lg={6} md={6} sm={12} xs={12}>
            <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
              <h3 className="poppinsMedium text-left pt-3 w-100" style={{ color: "#2E2E2E" }}>Job Openings</h3>
            </motion.div>
          </Grid>
          <Grid item container lg={3.8} md={3.8} sm={12} xs={12} display={"flex"} marginTop={window.innerWidth > 768 ? 0 : "4%"}>
            <Grid item container backgroundColor={"#FAC3BD"} className="borderRadius8 p-2" display={"flex"} justifyContent={"center"} alignItems={"center"}>
              <p className="poppinsRegular text-black text-center"><FaExclamation color={"#8F281D"} size={20} />{" "}Applicant can only apply for one position at a time</p>
            </Grid>
          </Grid>
        </Grid>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
          <Grid item container height={"750px"} overflow={"scroll"} lg={12} flexWrap={"wrap"} justifyContent={"space-between"}>
            {RecentJobs?.length > 0 ?
              (RecentJobs?.map((val, index) => {
                return (
                  <Grid item container key={index} lg={3.8} md={3.8} sm={12} className="borderRadius10 my-3" sx={{ backgroundColor: "#313131", boxShadow: "0px 4px 28.3px 0px #A0B8A799" }}>
                    <Grid item container lg={12} className="p-3">
                      <h3 className="text-white poppinsMedium text-left">{val?.job_name}</h3>
                      <Grid item container lg={12} md={12} sm={12} xs={12} className="mt-3" justifyContent={"space-between"}>
                        <Grid item container lg={5.8} md={5.8} sm={5.8} xs={5.8} flexWrap={"wrap"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                          <p style={{ color: "#C9C9C9" }} className="fontSize12 poppinsMedium text-left">Closing Date</p>
                          <p className="fontSize12 Text-Prime-Gray poppinsMedium text-left" style={{ color: "#E77E72" }}>{OnlyDateConverter(val?.job_end_date)}</p>
                        </Grid>
                        <Grid item container lg={5.8} md={5.8} sm={5.8} xs={5.8} flexWrap={"wrap"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                          <p style={{ color: "#C9C9C9" }} className="fontSize12 poppinsMedium text-left">No. of Openings</p>
                          <p className="text-white poppinsMedium text-left">{val?.openings_count ? FormatAmount(val?.openings_count) : "--"}</p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider className="mt-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
                    <Grid item container lg={12} md={12} sm={12} xs={12}>
                      <Grid item container className="pt-3" lg={12} md={12} sm={12} xs={12} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"flex-start"}>
                        <ul>
                          {val?.job_qualifications?.slice(0,3)?.map((row, i) => {
                            return (
                              <li key={i} style={{ color: "#EBEBEB" }} className="poppinsRegular text-left pb-3 pr-3">{row?.name}</li>
                            )
                          })}
                        </ul>
                      </Grid>
                      <Grid item className="px-3 pb-5" lg={12} md={12} sm={12} xs={12}>
                        <p style={{ color: "#94FBBD" }} className={"pointer poppinsSemiBold text-left"} role="presentation" onClick={() => OpenDetailModal(val)}>
                          See More...
                        </p>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} justifyContent={"center"} sx={{ padding: "0% 4% 4% 4%" }}>
                        <GreenColorButton className="py-2 w-100" sx={{ backgroundColor: "#BEFFCC", borderRadius: "20px", color: "#000" }} onClick={() => OpenAgreementModal(val)}><h5>APPLY NOW</h5></GreenColorButton>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              }))
              :
              <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                <h5 className="text-black poppinsMedium mt-3 mb-3">No Jobs List Available</h5>
              </Grid>
            }
          </Grid>
        </motion.div>
      </Grid>
      <Grid item container lg={12} md={12} sm={12} xs={12} alignItems={"center"} padding={window.innerWidth > 768 ? "2% 4%" : 2} className="bg-white">
        <Grid item container lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <h3 className="poppinsMedium text-left" style={{ color: "#2E2E2E" }}>Latest News</h3>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <button 
              style={{ 
                color: "#306A47", 
                background: "none", 
                border: "none", 
                cursor: "pointer",
                textDecoration: "underline"
              }} 
              className="poppinsSemiBold text-black text-center pointer"
              onClick={() => window.open("https://psc.gov.ng/news/", "_blank", "noopener,noreferrer")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  window.open("https://psc.gov.ng/news/", "_blank", "noopener,noreferrer");
                }
              }}
            >
              View more..
            </button>
          </motion.div>
        </Grid>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
          <NewsSection
            news={latestNews}
            loading={newsLoading}
            error={newsError}
            onRetry={GetLatestNews}
            onNewsClick={handleNewsClick}
            getNewsImage={getNewsImage}
          />
        </motion.div>
      </Grid>
      <Grid item container>
        <Footer />
      </Grid>
      <CustomModal
        open={detailModal}
        setOpen={CloseDetailModal}
        divider={false}
        header={true}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            View Post Details
          </h5>
        }
        width={window.innerWidth > 600 ? "55%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
          textAlign={"left"}
        >
          <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"space-between"}>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">Job Name</p>
              <p className="poppinsNormal Text-Prime-Black text-left">{jobDetails?.job_name ? jobDetails?.job_name : "--"}</p>
            </Grid>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">  Start Date</p>
              <p className="poppinsNormal Text-Prime-Black  text-left">{jobDetails?.job_start_date ? OnlyDateConverter(jobDetails?.job_start_date) : "--"}</p>
            </Grid>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left"> Close Date</p>
              <p className="poppinsNormal Text-Prime-Black text-left">{jobDetails?.job_end_date ? OnlyDateConverter(jobDetails?.job_end_date) : "--"}</p>
            </Grid>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">Number of Opening</p>
              <p className="poppinsNormal Text-Prime-Black text-left">{jobDetails?.openings_count ? FormatAmount(jobDetails?.openings_count) : "--"}</p>
            </Grid>
          </Grid>
          <Divider className="w-100 mt-2" sx={{ border: "1px solid #a7aba96e" }} />

          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">Here are the requirements for the role of {jobDetails?.job_name || "this position"}:</p>

          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Educational Qualification:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. A Bachelor&apos;s degree or equivalent qualification from a recognized institution.</p>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">2. Candidates must provide a certificate or academic transcripts as proof of education.</p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Age Requirement:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. Candidates should typically be between 20 and 28 years of age (specific age requirements may vary by region or recruitment cycle).</p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Nationality:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. Must be a citizen of Nigeria.</p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Physical Fitness:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. Good physical and mental health is required. </p>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">2. Candidates must pass a physical fitness test, which may include endurance and strength exercises. </p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Medical and Psychological Evaluation:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. Must pass a medical examination and psychological evaluation to ensure fitness for duty. </p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Height Requirement:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. Male candidates should be at least 1.67 meters (5 feet 6 inches) tall. </p>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">2. Female candidates should be at least 1.64 meters (5 feet 4 inches) tall. </p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Good Character:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. No criminal record or involvement in any criminal activities.</p>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">2. Candidates must have a clear record, verified by background checks.</p>
          <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Other Skills:</h5>
          <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1.Strong communication, problem-solving, and decision-making skills are an advantage.</p>

        </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5"
              onClick={() => CloseDetailModal()}
            >
              Close
            </PrimeGrayBorderColorButton>

          </Grid>
        }
      />
      <CustomModal
        open={applicationAgreement}
        setOpen={CloseAgreementModal}
        divider={false}
        header={true}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            Application Agreement
          </h5>
        }
        width={window.innerWidth > 600 ? "60%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
          textAlign={"left"}
          className="px-2"

        >
          <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"space-between"}>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">Post Name</p>
              <p className="poppinsNormal Text-Prime-Black text-left">{jobDetails?.title ? jobDetails?.title : "--"}</p>
            </Grid>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">Start Date</p>
              <p className="poppinsNormal Text-Prime-Black  text-left">{jobDetails?.createdOn ? OnlyDateConverter(jobDetails?.createdOn) : "--"}</p>
            </Grid>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">Close Date</p>
              <p className="poppinsNormal Text-Prime-Black text-left">{jobDetails?.closingDate ? OnlyDateConverter(jobDetails?.closingDate) : "--"}</p>
            </Grid>
            <Grid item container lg={2.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="text-black poppinsMedium pb-2 text-left">Number of Opening</p>
              <p className="poppinsNormal Text-Prime-Black text-left">{jobDetails?.numberOfOpenings ? FormatAmount(jobDetails?.numberOfOpenings) : "--"}</p>
            </Grid>
          </Grid>
          <Divider className="w-100 mt-2" sx={{ border: "1px solid #a7aba96e" }} />

          <Grid item lg={12} md={12} sm={12} xs={12} container flexDirection={"column"} >

            <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">Instructions for the Candidate:</h5>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              Please review and agree to the terms before proceeding with your application.
            </p>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">1. Accuracy of Information: </p>
            <p className="poppinsNormal Text-Prime-Black p-2 text-left">
              I confirm that all information provided in this application is accurate and true to the best of my knowledge. Any falsification may result in disqualification or legal consequences.
            </p>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              2. Eligibility Criteria:
            </p>
            <p className="poppinsNormal Text-Prime-Black p-2 text-left">
              I confirm that I meet the minimum qualifications, educational requirements, and other eligibility criteria specified for this government position.
            </p>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              3. Documentation Requirements:
            </p>
            <p className="poppinsNormal Text-Prime-Black p-2 text-left">
              I understand that I must provide all required documentation (e.g., national ID, educational certificates, professional qualifications) at each stage of the application process.
            </p>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              4. Stage Completion:</p>
            <p className="poppinsNormal Text-Prime-Black p-2 text-left">I agree to complete all stages of the recruitment process (physical test, CBT, medical test) as required. Failure to complete any stage may lead to my disqualification.
            </p>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              5. Compliance with Government Policies:
            </p>
            <p className="poppinsNormal Text-Prime-Black p-2 text-left"> I understand that I must comply with all government rules, policies, and regulations associated with this recruitment process. </p>
            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">6. Final Decision: </p>
            <p className="poppinsNormal Text-Prime-Black p-2 text-left"> I acknowledge that the final selection decision rests solely with the recruitment board, and my application status may be changed at any stage based on my compliance and performance.</p>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} container flexDirection={"column"} >

            <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"nowrap"} alignItems={"center"}>
              <CustomCheckBox
                disableColor={"transparent"}
                checked={aggrement.Q1 == true ? true : false}
                onChange={() => ChangeAggrement(!aggrement.Q1, "Q1")}
              />
              <p className="poppinsNormal Text-Prime-Black text-left">I have thoroughly reviewed the recruitment notification and the instructions provided for applicants.  I understand that it is my responsibility to submit correct and error-free details.</p>
            </Grid>
            <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"nowrap"} alignItems={"center"}>
              <CustomCheckBox
                disableColor={"transparent"}
                checked={aggrement.Q2 == true ? true : false}
                onChange={() => ChangeAggrement(!aggrement.Q2, "Q2")}
              />
              <p className="poppinsNormal Text-Prime-Black text-left">I will ensure that all information provided in the online application is accurate and free of errors.</p>
            </Grid>
            <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"nowrap"} alignItems={"center"}>
              <CustomCheckBox
                disableColor={"transparent"}
                checked={aggrement.Q3 == true ? true : false}
                onChange={() => ChangeAggrement(!aggrement.Q3, "Q3")}
              />
              <p className="poppinsNormal Text-Prime-Black text-left">I understand that it is my responsibility to submit correct and error-free details.</p>
            </Grid>

          </Grid>
        </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5"
              onClick={() => CloseAgreementModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
            <GreenColorButton className="px-3 py-2 ml-2" onClick={() => OpenApplication()}>Agree & Proceed</GreenColorButton>
          </Grid>
        }
      />
    </Grid>
  );
};

export default LandingPage;